export function getJson(data) {
    return typeof data === 'string' && isJson(data) ? data : JSON.stringify(data);
}
export function isJson(str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
}
export function stringify(object) {
    const kv = object;
    const searchParams = new URLSearchParams();
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(kv)) {
        searchParams.set(key, String(value));
    }
    return searchParams.toString();
}
export function isJsonContentType(contentType) {
    return typeof contentType === 'string' ? contentType.includes('application/json') : false;
}
export function isTextContentType(contentType) {
    return typeof contentType === 'string' ? contentType.includes('text/plain') : false;
}
export async function parseDataByType(response) {
    let data = null;
    let contentType = response.headers.get('Content-type');
    if (isJsonContentType(contentType))
        data = await response.json();
    else if (isTextContentType(contentType))
        data = await response.text();
    return data;
}
function isObject(value) {
    return value !== undefined &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        value !== null;
}
export function isJsonResponse(response, headers) {
    if (!isObject(response)) {
        return false;
    }
    const headersObj = headers !== null && headers !== void 0 ? headers : ('headers' in response && isObject(response.headers) ? response.headers : undefined);
    let contentType = '';
    if (headersObj) {
        if ('get' in headersObj && typeof headersObj.get === 'function') {
            contentType = headersObj.get('Content-type');
        }
        else if ('content-type' in headersObj) {
            contentType = '' + headersObj['content-type'];
        }
    }
    return isJsonContentType(contentType) && 'json' in response;
}
